import React, { useState } from 'react';
import { TextField } from '@mui/material';
import useApiControl from '../../../common/useApiControl';
import UserUpdateDialog from '../../dialogs/UserUpdateDialog';
import BaseForm from '../BaseForm';

function PasswordEditForm() {
  const [form, setForm] = useState({
    password: '',
    password_confirmation: '',
  });
  const [userUpdateDialogVisible, setUserUpdateDialogVisible] = useState(false);

  const { error, executeRequest: updatePassword } = useApiControl({
    action: '/update_password',
    params: form,
    method: 'POST',
  });

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleDialogClose = () => {
    setUserUpdateDialogVisible(false);
    window.location.reload();
  };

  const handleSubmit = () => {
    updatePassword(form).then(() => {
      setForm({
        password: '',
        password_confirmation: '',
      });
      setUserUpdateDialogVisible(true);
    });
  };

  return (
    <>
      <UserUpdateDialog
        isVisible={userUpdateDialogVisible}
        onClose={handleDialogClose}
        message="パスワードの更新が完了しました。"
      />
      <h2>パスワード設定</h2>
      <BaseForm
        onSubmit={handleSubmit}
        submitLabel="パスワードを保存"
        logMessage="password Update Api start"
        apiError={error}
      >
        <TextField
          label="新しいパスワード"
          type="password"
          value={form.password}
          onChange={handleChange('password')}
          autoComplete="new-password"
          helperText="6文字以上で入力してください。"
        />

        <TextField
          label="新しいパスワード（確認）"
          type="password"
          value={form.password_confirmation}
          onChange={handleChange('password_confirmation')}
          autoComplete="new-password"
        />
      </BaseForm>
    </>
  );
}

export default PasswordEditForm;
